/**
 * FormSelect component for rendering select fields with Formik.
 * This includes the label, the select itself and error message.
 *
 * ## Example usage:
 *
 *   ...
 */
import React from 'react'
import { ErrorMessage, Field } from 'formik'
import { Tooltip } from '../Tooltip'
import { SelectElement } from '../../components/ui/select'

type FormSelectProps = {
    name: string
    label: string
    placeholder?: string
    options: { label: string; value: any }[]
    required?: boolean
    // text, email, password, ...
    // type?: string
    tooltip?: string | React.ReactNode
    // e.g. "numeric" for OIB field or other number only fields
    // inputMode?: React.HTMLAttributes<HTMLElement>['inputMode']
}

export function FormSelect({ label, name, tooltip, placeholder, options, required = false, ...props }: FormSelectProps) {
    return (
        <div className="flex flex-col gap-1.5">
            <div className="flex gap-1 items-center w-full">
                <label htmlFor={name} className="text-grey100 font-sm-bold">
                    {label}
                </label>
                {required ? <span className="text-red20">*</span> : null}
                {tooltip ? <Tooltip>{tooltip}</Tooltip> : null}
            </div>

            <Field name={name}>
                {({ field, form }: any) => {
                    const hasError = form.errors[name] && form.touched[name]

                    return (
                        <SelectElement
                            name={name}
                            value={field.value}
                            onValueChange={value => {
                                form.setFieldValue(field.name, value)
                            }}
                            placeholder={placeholder}
                            options={options}
                            error={hasError}
                        />
                    )
                }}
            </Field>

            <ErrorMessage name={name} component="span" className="text-sm text-red20" />
        </div>
    )
}
